module.exports = __webpack_public_path__ + "assets/img/102.3c6aaa57.png";